<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          ref="searchItem"
          config-module="9210"
          :is-simple-query="false"
          :custom-sim-query-placeholder="$t('CargoMsg.Cargo_PlsInput') + ':' + ($t('CargoMsg.Cargo_RouteProductName'))"
          @click-more="value=>{isAdvancedQuery=value}"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="queryHandler"
        >

          <div slot="operations">
            <el-button type="primary" @click="addAirlineProductHandler">{{ $t('CargoMsg.Cargo_Add') }}</el-button>
            <el-button
              :disabled="!(selectedRows && selectedRows.length > 0)"
              type="success"
              @click="editHandler"
            >{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <!--            <el-button-->
            <!--              :disabled="!(selectedRows && selectedRows.length > 0)"-->
            <!--              type="danger-->
            <!--              @click="delHandler"-->
            <!--            >{{ $t('CargoMsg.Cargo_Delete') }}</el-button>-->
          </div>
        </search-item>
        <div style="flex-grow: 1;min-height: 350px;">
          <cargo-ag-grid-wrapper
            config-module="202206071"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :show-selected-color="false"
            :check-sub-record="false"
            style="height: 100%;"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            config-module="202206071"
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="fetchDataByPage"
          />
        </div>
      </div>
    </div>
    <el-dialog
      v-if="airlineProductDialog.visible"
      v-el-drag-dialog
      :visible.sync="airlineProductDialog.visible"
      :title="airlineProductDialog.title"
      width="1150px"
      :close-on-click-modal="false"
    >
      <el-form class="airline-product-form" style="display: flex;flex-wrap: wrap" :label-width="$selectByLang('100px', '140px')" label-position="left">
        <el-form-item :label="$t('CargoMsg.Cargo_RouteProductCode')" required>
          <el-input v-model="airlineProductDialog.form.code" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_RouteProductName')" required>
          <el-input v-model="airlineProductDialog.form.name" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_ServiceProduct')" required>
          <cargo-advance-select
            ref="serviceProduct"
            :select-type="TYPE_NAMES.basic_data_AirServiceProduct"
            callback-method-type="value"
            :default-value="airlineProductDialog.form.serviceProduct"
            :callback-params="{key:'serviceProduct'}"
            @parentCallBack="setSelectValue"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Airline2')" required>
          <cargo-advance-select
            no="carrierId"
            filterable
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{airCmp:true, companyLob:'airExport',active:true}"
            :default-value="airlineProductDialog.form.carrierId||''"
            :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
            :fields="['shortName', 'chineseName']"
            placeholder=" "
            @parentCallBack="p => {airlineProductDialog.form.carrierId=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_PurchaseMethod')" required>
          <cargo-advance-select
            ref="purchaseMethod"
            tag-value="code"
            :static-options="SystemConstants.PURCHASE_METHODS"
            :default-value="airlineProductDialog.form.purchaseMethod"
            @parentCallBack="p=>{airlineProductDialog.form.purchaseMethod=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_PurchaseSource')" required>
          <cargo-advance-select
            no="purchaseSource"
            filterable
            :select-type="TYPE_NAMES.basic_data_Company"
            :method-params="{active:true}"
            :default-value="airlineProductDialog.form.purchaseSource||''"
            :headers="[$t('Tool.ShortName'),$t('Partners.chineseName')]"
            :fields="['shortName', 'chineseName']"
            placeholder=" "
            @parentCallBack="p => {airlineProductDialog.form.purchaseSource=p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_OriginPort')" required>
          <cargo-advance-select
            ref="portOfDeparture"
            no="portOfDeparture"
            filterable
            :select-type="TYPE_NAMES.basic_data_Airport"
            :default-value="airlineProductDialog.form.portOfDeparture"
            style="flex:1"
            tag-name="englishName"
            placeholder=" "
            @parentCallBack="p=>{airlineProductDialog.form.portOfDeparture = p.value}"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_RouteOfficer')">
          <cargo-multi-user-select
            no="airlineOperator"
            :method-params="{officeId:$store.getters.currentOfficeId}"
            :default-multiple-value="airlineProductDialog.form.airlineOperatorList || []"
            placeholder=" "
            @parentCallBack="airlineOperator"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_EffectiveDate')" required>
          <el-date-picker
            v-model="airlineProductDialog.form.beginDate"
            no="beginDate"
            type="date"
            :picker-options="beginDatePickerOptions"
            value-format="yyyy-MM-dd"
            style="width: 300px"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_InvalidDate')" required>
          <el-date-picker
            v-model="airlineProductDialog.form.endDate"
            no="endDate"
            type="date"
            :picker-options="endDatePickerOptions"
            value-format="yyyy-MM-dd"
            style="width: 300px"
          />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_Remarks')">
          <el-input v-model="airlineProductDialog.form.remarks" :rows="6" type="textarea" style="width: 300px" />
        </el-form-item>
        <el-form-item :label="$t('CargoMsg.Cargo_IsEffective')">
          <el-checkbox v-model="airlineProductDialog.form.active" no="active" style="width: 300px" />
        </el-form-item>
      </el-form>
      <div style="height: 305px">
        <el-tabs v-model="airlineProductDialog.activeName" style="height: 100%" type="card" @tab-click="handleTabClick">
          <el-tab-pane :label="$t('CargoMsg.Cargo_VoyageNo')" name="airlineProductVoyage">
            <airline-product-voyage ref="airlineProductVoyage" :row-data="airlineProductDialog.form.voyages" />
          </el-tab-pane>
          <el-tab-pane :label="$t('CargoMsg.Cargo_PrimeCost')" name="airlineProductVoyageCost">
            <airline-product-voyage-cost ref="airlineProductVoyageCost" :form="airlineProductDialog.form" />
          </el-tab-pane>
        </el-tabs>
      </div>
      <span slot="footer">
        <el-button type="primary" @click="commitHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
        <el-button @click="airlineProductDialog.visible=false">{{ $t('Message.Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInputNumber from '@/components/Cargo/Common/cargoInputNumber'
import cargoNumericStepper from '@/components/Cargo/Common/cargoNumericStepper'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import {
  deleteAirlineProduct,
  detailAirlineProduct,
  queryAirlineProducts,
  saveAirlineProduct
} from '@/api/booking/airlineProduct'
import { AirlineProduct } from '@/class/model/booking/AirlineProduct'
import { AirlineProductVoyage } from '@/class/model/booking/AirlineProductVoyage'
import { DATA_TYPE_LEVEL_1, WEEKS } from '@/class/cargo/model/parameters/SystemConstants'
import * as RadioStatusConstants from '@/class/cargo/model/parameters/RadioStatusConstants'
import airlineProductVoyage from '@/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyage'
import airlineProductVoyageCost from '@/views/cargo/v0/AirExport/components/airlineProduct/airlineProductVoyageCost'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper.vue'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import cargoMultiUserSelect from '@/components/Cargo/Common/cargoMultiUserSelect'

export default {
  name: 'AirlineProduct',
  components: { cargoAgGridWrapper, searchItem, CargoButtonGroupSlider, cargoAdvanceSelect, cargoInputNumber, cargoNumericStepper, airlineProductVoyage, airlineProductVoyageCost, cargoUserSelect, cargoMultiUserSelect },
  data() {
    return {
      SystemConstants, RadioStatusConstants,
      loading: false,
      TYPE_NAMES,
      isAdvancedQuery: false, // 是否为高级查询
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true，则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        treeData: true,
        groupDefaultExpanded: 2,
        getDataPath: data => {
          if (data.path) {
            return data.path.split(',')
          }
          return ''
        },
        autoGroupColumnDef: {
          headerName: this.$t('CargoMsg.Cargo_RouteProductCode'),
          colId: 'code',
          field: 'code',
          width: 160,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: true,
            checkbox: params => {
              const data = params.data
              if (data.hasOwnProperty('dataType') && Number(data.dataType) === DATA_TYPE_LEVEL_1.code) {
                return true
              }
              return false
            },
            innerRenderer: params => {
              return params.value
            }
          },
          tooltip: params => {
            return params.data.code
          },
          suppressMenu: true,
          pinned: 'left'
        },
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.selectedRows = this.gridApi.getSelectedRows()
        },
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: this.$t('CargoMsg.Cargo_RouteProductName'),
          field: 'name',
          colId: 'name',
          width: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_ServiceProduct'),
          field: 'serviceProduct',
          colId: 'serviceProduct',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_AirServiceProduct, 'productId', params.value, 'productName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Airline2'),
          field: 'carrierId',
          colId: 'carrierId',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PurchaseMethod'),
          field: 'purchaseMethod',
          colId: 'purchaseMethod',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.PURCHASE_METHODS)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_PurchaseSource'),
          field: 'purchaseSource',
          colId: 'purchaseSource',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          },
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_OriginPort'),
          field: 'portOfDeparture',
          colId: 'portOfDeparture',
          width: 100
          // cellRenderer: (params) => {
          //   return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'chineseName')
          // }
        }, {
          headerName: this.$t('CargoMsg.Cargo_VoyageNo'),
          field: 'voyage',
          colId: 'voyage',
          editable: false,
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, SystemConstants.WEEKS)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_TransferPort') + '1',
          field: 'dischargingPort1',
          colId: 'dischargingPort1',
          width: 100,
          // cellRenderer: (params) => {
          //   return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'chineseName')
          // },
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_TransferPort') + '2',
          field: 'dischargingPort2',
          colId: 'dischargingPort2',
          width: 100,
          // cellRenderer: (params) => {
          //   return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'chineseName')
          // },
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_DestinationPort'),
          field: 'destinationPortCode',
          colId: 'destinationPortCode',
          width: 100
          // cellRenderer: (params) => {
          //   return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'chineseName')
          // }
        }, {
          headerName: this.$t('CargoMsg.Cargo_TransshipmentPort'),
          field: 'transshipmentPort',
          colId: 'transshipmentPort',
          width: 100,
          // cellRenderer: (params) => {
          //   return ColumnUtils.resolveMultipleColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value, 'chineseName')
          // },
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_RouteOfficer'),
          field: 'airlineOperator',
          colId: 'airlineOperator',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.resolveMultipleColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Remarks'),
          field: 'remarks',
          colId: 'remarks',
          width: 100,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_IsEffective'),
          field: 'active',
          width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, RadioStatusConstants.YES_NO_TYPES)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_EffectiveDate'),
          field: 'beginDate',
          colId: 'beginDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150,
          hide: true
        }, {
          headerName: this.$t('CargoMsg.Cargo_InvalidDate'),
          field: 'endDate',
          colId: 'endDate',
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          },
          width: 150,
          hide: true
        }
      ],
      rowData: [],
      selectedRows: [],
      gridApi: null,
      airlineProductDialog: {
        visible: false,
        title: '',
        form: new AirlineProduct().fillDefaultValue().getData(),
        activeName: 'airlineProductVoyage'
      },
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10
      },
      beginDatePickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledBeginDate
      },
      endDatePickerOptions: { // 设置可选时间范围
        disabledDate: this.disabledEndDate
      }
    }
  },
  created() {
    this.queryHandler()
  },
  methods: {
    disabledBeginDate(date) {
      const endDate = this.airlineProductDialog.form.endDate
      if (!endDate) {
        return false // 如果没有选择开始日期，结束日期不限制
      }
      const endDateWithoutHMS = new Date(endDate)
      const currentDate = new Date(date)
      // 如果结束日期距离开始日期超过3年，则禁用该日期
      const minBeginDate = new Date(endDate)
      minBeginDate.setFullYear(minBeginDate.getFullYear() - 3)
      minBeginDate.setHours(0, 0, 0, 0)
      return currentDate < minBeginDate || currentDate > endDateWithoutHMS
    },
    disabledEndDate(date) {
      const beginDate = this.airlineProductDialog.form.beginDate
      if (!beginDate) {
        return false // 如果没有选择开始日期，结束日期不限制
      }
      const beginDateWithoutHMS = new Date(beginDate)
      beginDateWithoutHMS.setHours(0, 0, 0, 0)
      const currentDate = new Date(date)
      // 如果结束日期距离开始日期超过3年，则禁用该日期
      const maxEndDate = new Date(beginDate)
      maxEndDate.setFullYear(maxEndDate.getFullYear() + 3)
      maxEndDate.setHours(0, 0, 0, 0)
      return currentDate > maxEndDate || currentDate < beginDateWithoutHMS
    },
    setSelectValue(obj) {
      this.airlineProductDialog.form[obj.key] = obj.value
    },
    // 分页触发查询
    fetchDataByPage() {
      this.queryHandler(this.filter.conditions)
    },
    // 简单查询
    toSimpleQuery(keyword) {
      if (!keyword) {
      // 覆盖原查询条件
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + (this.$t('CargoMsg.Cargo_RouteProductName')))
        return
      }
      const data = [new AdvancedSearchOption(null, 'NAME', keyword, 'LIKE').formatObj2Json()]
      this.queryHandler(data)
    },
    queryHandler(data) {
      if (data) {
        this.filter.conditions = data
      }
      this.loading = getLoading4Cxt()
      this.filter.branchId = this.$store.getters.currentOfficeId
      queryAirlineProducts(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
      }).finally(() => {
        this.loading.close()
      })
    },
    addAirlineProductHandler() {
      this.airlineProductDialog.activeName = 'airlineProductVoyage'
      this.airlineProductDialog.title = this.$t('CargoMsg.Cargo_AirlineProductCode') + '-' + this.$t('CargoMsg.Cargo_Add')
      this.airlineProductDialog.form = new AirlineProduct().fillDefaultValue().getData()
      this.airlineProductDialog.form.voyages = []
      WEEKS.forEach(week => {
        const e = new AirlineProductVoyage().fillDefaultValue().getData()
        e.voyage = week.code
        e.serialNumber = week.code
        e.active = false
        e.voyageBoards = []
        e.voyageCosts = []
        e.transshipmentPortList = []
        this.airlineProductDialog.form.voyages.push(e)
      })
      this.airlineProductDialog.visible = true
    },
    commitHandler() {
      const form = this.airlineProductDialog.form
      if (!form.code || !form.code.trim()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_RouteProductCode'))
        return
      }
      if (!form.name || !form.name.trim()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PlsInput') + this.$t('CargoMsg.Cargo_RouteProductName'))
        return
      }
      if (!form.serviceProduct) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_ServiceProduct'))
        return
      }
      if (!form.carrierId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Airline2'))
        return
      }
      if (!form.purchaseMethod) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_PurchaseMethod'))
        return
      }
      if (!form.portOfDeparture) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_OriginPort'))
        return
      }
      if (!form.beginDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_EffectiveDate'))
        return
      }
      if (!form.endDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_InvalidDate'))
        return
      }
      if (form.beginDate > form.endDate) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EffectiveDateMustBeLessThanTheExpirationDate2'))
        return
      }
      if (!this.$refs.airlineProductVoyage.check()) {
        return
      }
      if (!this.$refs.airlineProductVoyageCost.check()) {
        return
      }
      form.delVoyageKeys = this.$refs.airlineProductVoyage.delVoyageKeys
      form.delVoyageBoardKeys = this.$refs.airlineProductVoyage.delVoyageBoardKeys
      form.delVoyageCostKeys = this.$refs.airlineProductVoyageCost.delVoyageCostKeys
      form.branchId = this.$store.getters.currentOfficeId
      this.loading = getLoading4Cxt()
      saveAirlineProduct(form).then(res => {
        this.queryHandler()
        this.airlineProductDialog.visible = false
        this.$message.success(this.$t('Message.SaveSuccessfully'))
      }).finally(() => {
        this.loading.close()
      })
    },
    delHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }

      const uuids = rows.map(row => row.uuid)
      this.loading = getLoading4Cxt()
      deleteAirlineProduct(uuids).then(res => {
        this.queryHandler()
      }).finally(() => {
        this.loading.close()
      })
    },
    editHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const uuids = rows.map(row => row.uuid)
      if (uuids.length > 1) {
        this.$message.error(this.$t('SeaExport.OnlyCheckOneData'))
        return
      }
      this.loading = getLoading4Cxt()
      detailAirlineProduct({ uuid: uuids[0] }).then(res => {
        this.airlineProductDialog.activeName = 'airlineProductVoyage'
        this.airlineProductDialog.title = this.$t('CargoMsg.Cargo_AirlineProductCode') + '-' + this.$t('CargoMsg.Cargo_Edit')
        this.airlineProductDialog.form = res.data
        if (this.airlineProductDialog.form.airlineOperator) {
          this.airlineProductDialog.form.airlineOperatorList = this.airlineProductDialog.form.airlineOperator.split(',').map(Number)
        }
        this.airlineProductDialog.visible = true
        for (const voyage of this.airlineProductDialog.form.voyages) {
          if (!voyage.transshipmentPortList) {
            voyage.transshipmentPortList = []
          }
          if (!voyage.voyageBoards) {
            voyage.voyageBoards = []
          }
          if (!voyage.voyageCosts) {
            voyage.voyageCosts = []
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    handleTabClick() {
      if (this.airlineProductDialog.activeName === 'airlineProductVoyageCost') {
        this.$refs.airlineProductVoyageCost.init()
      }
    },
    airlineOperator(p) {
      this.airlineProductDialog.form.airlineOperatorList = [...p.userId]
      this.airlineProductDialog.form.airlineOperator = p.userId.join(',')
    }
  }
}
</script>

<style scoped lang="scss">
  .input-label {
    display: inline-block;
    width: 60px;
    color: #666666;
  }
  .airline-product-form .lable-blue ::v-deep {
    .el-form-item__label {
      color: blue !important;
    }
  }
  .airline-product-form .el-form-item {
    margin-left: 20px;
  }
  .el-form{
    /deep/ .el-input__inner{
      width: 300px;
    }
  }
</style>
